module.exports = __webpack_public_path__ + "static/media/pexels-brett-sayles-2881224.e27e5a3e.jpg";